import { NgModule } from '@angular/core';
import { GlobalLayoutComponent } from './global-layout.component';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { ProfileMenuComponent } from './components/profile-menu/profile-menu.component';
import { CoreModule } from '@app/core/core.module';
import { AlertsMenuComponent } from './components/alerts-menu/alerts-menu.component';
import { NavigationComponent } from './components/navigation/navigation.component';
import { SettingsComponent } from './components/settings/settings.component';
import { NotificationsComponent } from './components/notifications/notifications.component';
import { NavigationItemComponent } from './components/navigation-item/navigation-item.component';
import { PackhouseConnectivityComponent } from './components/packhouse-connectivity/packhouse-connectivity.component';
import { NotificationsV2Component } from './components/notifications-v2/notifications-v2.component';
import { SupportMenuComponent } from './components/support-menu/support-menu.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    CoreModule,
    GlobalLayoutComponent,
    ProfileMenuComponent,
    AlertsMenuComponent,
    NavigationComponent,
    SettingsComponent,
    NotificationsComponent,
    NotificationsV2Component,
    NavigationItemComponent,
    PackhouseConnectivityComponent,
    SupportMenuComponent,
  ],
  exports: [GlobalLayoutComponent],
})
export class GlobalLayoutModule {}
